module.exports = __webpack_public_path__ + "img/platform-3.74b4f24f.png";